import { call, put, takeEvery } from 'redux-saga/effects';
import { CHANGE_USER_STATUS_REQUEST } from '../constants/change_user_status.constants';
import { changeUserStatus } from '../../requests/change_user_status_request';
import { changeUserStatusRequestSuccess, changeUserStatusRequestFailure } from '../actions/change_user_status.actions';
import { message_success, message_error } from '../../../../../components/Message';

function* changeUserStatusRequest({ params, callback }) {
    const { _id, status } = params; const
        status_info = yield call(changeUserStatus, _id, status);
    try {
        yield put(changeUserStatusRequestSuccess(status_info));
        callback();
        message_success('User status has been changed!');
    } catch (error) {
        yield put(changeUserStatusRequestFailure(error));
        message_error('Ooops... Something went wrong!');
        callback();
    }
}

export default function* changeUserStatusSaga() {
    yield takeEvery(CHANGE_USER_STATUS_REQUEST, changeUserStatusRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/redux/sagas/change_user_status.saga.js